import clsx from "clsx";

import { SimCardDetailSimStatus } from "@/services/model";

const statusClassMapping: Record<SimCardDetailSimStatus, string> = {
  green: "bg-surface-success",
  yellow: "bg-surface-warning",
  red: "bg-surface-error",
  grey: "bg-surface-accent-beige",
  orange: "bg-surface-accent-orange",
};

interface Props {
  className?: string;
  color?: SimCardDetailSimStatus;
}

/** The coloured dot in the device list's status column. */
export const DeviceStatusIndicator = ({ className, color }: Props) => {
  const status = color ?? SimCardDetailSimStatus.green;

  return (
    <span
      data-testid="device-status-indicator"
      data-status={status}
      className={clsx(
        "inline-block size-4 rounded-full",
        statusClassMapping[status],
        className,
      )}
    />
  );
};
